import {
    ActionType, NetworkActionPrefix, PerformanceIndicatorCollectionType,
    PerformanceIndicatorComparisonCalculation, PerformanceIndicatorComparisonTarget, PerformanceIndicatorDateRange, PerformanceIndicatorDimension,
    PerformanceIndicatorFormulaElementType, PerformanceIndicatorPointCalculation, PerformanceIndicatorRelativePeriod,
    PerformanceIndicatorValueDependencyRule, PerformanceIndicatorValueSource, PerformancePerspective, PerformancePerspectiveGroup, PeriodType, RequestStatus
} from '../utils/constants';
import defaults from '../api/defaults';
import {
    combineReducers, networkActionReducer,
    networkEntityAddReducer, networkEntityDeleteReducer, networkEntityEditReducer,
    networkObjectLoadReducer, networkObjectVoidReducer, pipeReducers,
    synchronizableEnumReducer
} from '../utils/reducerFactory';
import { deepAssign, omit } from '../utils';
import { LOCATION_CHANGE } from 'react-router-redux';

// TODO merge to typed/reducers/indicators

function index(state, action, id) {
    return id !== undefined ? (id = state.getIndexByID(id)) !== -1 ? id : state.length : undefined;
}

const keyVariables = {
    indicatorIndex: (state, action) => index(state, action, action.indicatorID),
    performanceManagementAlertIndex: (state, action) => index(state, action, action.performanceManagementAlertID)
};

export default combineReducers({
    performancePerspectives: synchronizableEnumReducer(NetworkActionPrefix.LOAD_ALL_PERFORMANCE_PERSPECTIVES_PREFIX, defaults.NetworkArray, PerformancePerspective, 'PerformancePerspective'),
    performancePerspectiveGroups: synchronizableEnumReducer(NetworkActionPrefix.LOAD_ALL_PERFORMANCE_PERSPECTIVE_GROUPS_PREFIX, defaults.NetworkArray, PerformancePerspectiveGroup, 'PerformancePerspectiveGroup'),
    periodTypes: pipeReducers(
        (state, action) => action.type === ActionType.EDIT_GENERAL_SETTINGS_SUCCESS ? defaults.NetworkArray : state,
        synchronizableEnumReducer(NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_PERIOD_TYPE_PREFIX, defaults.NetworkArray, PeriodType, 'PerformanceIndicatorPeriodType')
    ),
    dimensions: synchronizableEnumReducer(NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_DIMENSIONS_PREFIX, defaults.NetworkArray, PerformanceIndicatorDimension, 'PerformanceIndicatorDimension'),
    dateRanges: synchronizableEnumReducer(NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_DATE_RANGES_PREFIX, defaults.NetworkArray, PerformanceIndicatorDateRange, 'PerformanceIndicatorDateRange'),
    pointCalculations: synchronizableEnumReducer(NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_POINT_CALCULATIONS_PREFIX, defaults.NetworkArray, PerformanceIndicatorPointCalculation, 'PerformanceIndicatorPointCalculation'),
    comparisonTargets: synchronizableEnumReducer(NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_COMPARISON_TARGETS_PREFIX, defaults.NetworkArray, PerformanceIndicatorComparisonTarget, 'PerformanceIndicatorComparisonTarget'),
    comparisonCalculations: synchronizableEnumReducer(NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_COMPARISON_CALCULATIONS_PREFIX, defaults.NetworkArray, PerformanceIndicatorComparisonCalculation, 'PerformanceIndicatorComparisonCalculation'),
    valueSources: synchronizableEnumReducer(NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_VALUE_SOURCES_PREFIX, defaults.NetworkArray, PerformanceIndicatorValueSource, 'PerformanceIndicatorValueSource'),
    relativePeriods: synchronizableEnumReducer(NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_RELATIVE_PERIOD_PREFIX, defaults.NetworkArray, PerformanceIndicatorRelativePeriod, 'PerformanceIndicatorRelativePeriod'),
    collectionTypes: synchronizableEnumReducer(NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_COLLECTION_TYPE_PREFIX, defaults.NetworkArray, PerformanceIndicatorCollectionType, 'PerformanceIndicatorCollectionType'),
    valueDependencyRules: synchronizableEnumReducer(NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_VALUE_DEPENDENCY_RULE_PREFIX, defaults.NetworkArray, PerformanceIndicatorValueDependencyRule, 'PerformanceIndicatorValueDependencyRule'),
    indicators: pipeReducers(
        networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_PERFORMANCE_INDICATORS_PREFIX, defaults.NetworkArray),
        combineReducers({
            Data: pipeReducers(
                combineReducers({
                    '@indicatorIndex': pipeReducers(
                        networkEntityAddReducer(NetworkActionPrefix.ADD_PERFORMANCE_INDICATOR_PREFIX, null, (state, action) => action.indicator),
                        networkEntityEditReducer(NetworkActionPrefix.EDIT_PERFORMANCE_INDICATOR_PREFIX, null, (state, action) => action.indicator),
                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_PERFORMANCE_INDICATOR_PREFIX),
                        networkActionReducer(NetworkActionPrefix.TEST_PERFORMANCE_INDICATOR_FORMULA_PREFIX)
                    )
                }, keyVariables),
                (state, action) => {
                    switch (action.type) {
                        case ActionType.ADD_PERFORMANCE_INDICATOR:
                        case ActionType.EDIT_PERFORMANCE_INDICATOR:
                            return deepAssign(
                                state,
                                state
                                    .sortBy(({ PerformancePerspectiveGroupID }) => PerformancePerspectiveGroupID)
                                    .thenBy(({ Sort }) => Sort || Infinity)
                                    .thenBy(({ Name }) => Name)
                            );
                        default:
                            return state;
                    }
                }
            )
        }),
        networkObjectVoidReducer(ActionType.ADD_PERFORMANCE_INDICATOR_SUCCESS),
        networkObjectVoidReducer(ActionType.MERGE_FORMULA_ITEMS_SUCCESS),
        networkObjectVoidReducer(ActionType.VOID_ALL_PERFORMANCE_INDICATORS),
        networkObjectVoidReducer(ActionType.IMPORT_AND_PROCESS_GOOGLE_SHEETS_DATA_SUCCESS),
        (state, action) => {
            switch (action.type) {
                // TODO synchronize indicator list and overall dashboards data more precisely
                case ActionType.DELETE_PERFORMANCE_INDICATOR_SUCCESS:
                case ActionType.EDIT_PERFORMANCE_INDICATOR_SUCCESS:
                case ActionType.MERGE_FORMULA_ITEMS_FAIL:
                case ActionType.ADD_FINANCIAL_INDICATOR_BEFORE_ANOTHER_INDICATOR_SUCCESS:
                case ActionType.ADD_FINANCIAL_INDICATOR_AFTER_ANOTHER_INDICATOR_SUCCESS:
                case ActionType.ADD_FINANCIAL_INDICATOR_SUCCESS:
                case ActionType.DELETE_PRODUCT_SUCCESS:
                case ActionType.DELETE_GEO_AREA_SUCCESS:
                case ActionType.DELETE_CUSTOMER_SUCCESS:
                case ActionType.DELETE_TRACKING_LEVEL_1_ITEM_SUCCESS:
                case ActionType.DELETE_TRACKING_LEVEL_2_ITEM_SUCCESS:
                case ActionType.DELETE_TRACKING_LEVEL_3_ITEM_SUCCESS:
                case ActionType.DELETE_TRACKING_LEVEL_4_ITEM_SUCCESS:
                case ActionType.SPLIT_FINANCIAL_INDICATOR_TO_SUB_ACCOUNTS_SUCCESS:
                case ActionType.ADD_SEVERA_INTEGRATION_SETTINGS_SUCCESS:
                case ActionType.EDIT_SEVERA_INTEGRATION_SETTINGS_SUCCESS:
                case ActionType.DELETE_SEVERA_INTEGRATION_SETTINGS_SUCCESS:
                case ActionType.REPLACE_FINANCIAL_INDICATOR_GROUP_SUCCESS:
                case action.payload && action.payload.status === RequestStatus.SUCCEEDED ? 'ADD_FORESIGHT_SCENARIO' : null:
                    return defaults.NetworkArray;

                case 'ADD_STRATEGY_METRIC':
                case 'EDIT_STRATEGY_METRIC':
                case 'ADD_STRATEGIC_GOAL':
                case 'ADD_GOAL_METRIC':
                case 'ADD_ALL_GOAL_METRICS':
                case 'EDIT_GOAL_METRIC':
                case 'EDIT_ALL_GOAL_METRICS':
                case 'ADD_STRATEGIC_GOAL_MILESTONE_METRIC':
                case 'EDIT_STRATEGIC_GOAL_MILESTONE_METRIC':
                case 'ADD_STRATEGIC_PROGRAM_METRIC':
                case 'EDIT_STRATEGIC_PROGRAM_METRIC':
                    if (action.payload && action.payload.status === RequestStatus.SUCCEEDED) {
                        return defaults.NetworkArray;
                    }

                    return state;

                case ActionType.MERGE_FORMULA_ITEMS_PENDING:
                    return deepAssign(state, {
                        Data: {
                            [state.Data.getIndexByID(action.indicatorID)]: {
                                Formula: action.formulaItems.map(item => deepAssign(item, { Custom: { status: RequestStatus.PENDING } }))
                            }
                        }
                    });

                case ActionType.MERGE_FORMULA_ITEMS_SUCCESS:
                    return deepAssign(state, {
                        Data: {
                            [state.Data.getIndexByID(action.indicatorID)]: {
                                FilteredIndicatorFormulaDynamicFilter: action.useDynamicFilter && action.response.some(({ ElementTypeID }) =>
                                    ElementTypeID === PerformanceIndicatorFormulaElementType.FILTERED_INDICATOR
                                ),
                                Formula: action.response
                            }
                        }
                    });

                default:
                    return state;
            }
        }
    ),
    formulaElementTypes: synchronizableEnumReducer(NetworkActionPrefix.LOAD_ALL_PERFORMANCE_INDICATOR_FORMULA_ELEMENT_TYPES_PREFIX, defaults.NetworkArray, PerformanceIndicatorFormulaElementType, 'PerformanceIndicatorFormulaElementType'),
    indicatorListSettings: pipeReducers(
        (state, _action) => state || {
            expandedGroups: [],
            periods: 6
        },
        combineReducers({
            expandedGroups: (state, action) =>
                action.type === LOCATION_CHANGE && action.payload.pathname.startsWith('/indicators_and_tracking_levels/indicators') ?
                    (action.payload.query.expandedGroups || '').split('_').filter(v => +v).map(v => +v) :
                    state,
            periods: (state, action) =>
                action.type === LOCATION_CHANGE && action.payload.pathname.startsWith('/indicators_and_tracking_levels/indicators') ?
                    +(action.payload.query.periods || '6') :
                    state
        })
    ),
    copyIndicatorsData: (state, action) => {
        const newState = state || defaults.NetworkObject;
        return omit(networkActionReducer(NetworkActionPrefix.COPY_PERFORMANCE_INDICATOR_DATA_PREFIX, defaults.NetworkObject)(newState, action), 'Data');
    }

});
